export const GET_PODCAST = "GET_PODCAST";
export const GET_PODCAST_SUCCESS = "GET_PODCAST_SUCCESS";
export const GET_PODCAST_FAIL = "GET_PODCAST_FAIL";

export function getPodcast() {
  return {
    type: GET_PODCAST
  }
}
